import React from 'react'
import { Container, Grid, Paper, Typography, Fade } from '@mui/material'
import { PickingReportSearch } from './PickingReportSearch/PickingReportSearch'
import { PickingCards } from './PickingStatesSquare/PickingCards'
import { PickingStatesSquare } from './PickingStatesSquare/PickingStatesSquare'
import { usePickingReport } from '../Context/usePickingReport'
import { useStyles } from './style'
import { graphLoader } from '../../../images/graphLoader'

/*
Copyright 2022-06-08 por Jorge Parrado Ecomsur Holding S.A ©
Detalle: Crea reporte de picking
*/

export const PickingReportWrapper = () => {
  const {
    state: { loading }
  } = usePickingReport()
  const classes = useStyles()


  return (
    <Container maxWidth='xl'>
      <Typography variant='h4' component='h2' gutterBottom>
        Avances de Picking
      </Typography>

      <Paper elevation={1}>
        <PickingReportSearch />

        {loading ? (
          <Fade in={true}>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={12} style={{ textAlign: 'center' }}>
                <img
                  src={graphLoader}
                  alt='graph'
                  style={{
                    width: '211px',
                    height: '200px',
                    maxWidth: '211px',
                    minWidth: '200px',
                    opacity: '1',
                    borderRadius: '100px'
                  }}
                />
                <Typography
                  variant='h4'
                  color='textSecondary'
                  component='h4'
                  className={classes.textColor}
                >
                  {'Generando Reporte...'}
                </Typography>
              </Grid>
            </Grid>
          </Fade>
        ) : (
          <Fade in={true}>
            <div>
              <PickingCards />
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  height: '300px',
                  paddingBottom: '40px'
                }}
              >
                <PickingStatesSquare />
              </div>
            </div>
          </Fade>
        )}
      </Paper>

    </Container>
  )
}
